import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import style from "./CallButtons.module.sass";
import ButtonCall from "../ButtonCall/ButtonCall";
import IcoVideo from "../../../../../assets/images/ico-video.svg";
import IcoVideoNo from "../../../../../assets/images/ico-video-no.svg";
import IcoMic from "../../../../../assets/images/ico-mic.svg";
import IcoMicNo from "../../../../../assets/images/ico-mic-no.svg";
import IcoShare from "../../../../../assets/images/ico-share.svg";
import IcoShareNo from "../../../../../assets/images/ico-share-no.svg";
import IcoRec from "../../../../../assets/images/ico-rec.svg";
import IcoStop from "../../../../../assets/images/ico-stop.svg";
import EndCallButton from "../EndCallButton/EndCallButton";
import { LiveCallsContext } from "../LiveCalls";

function CallButtons(props) {
  const { translations } = props;
  const {
    onToggleCamera,
    onToggleAudio,
    onToggleLocalScreenShare,
    onToggleRemoteShareScreen,
    onToggleRecording,
    onCloseCall,
    showRemoteSharedScreen,
  } = React.useContext(LiveCallsContext);

  const [showMenu, setShowMenu] = useState(false);
  const menuRef = useRef();

  useOnClickOutside(menuRef, () => {
    setShowMenu(false);
  });

  // solution got from here: https://stackoverflow.com/a/68018429/1897170
  function useOnClickOutside(ref, handler) {
    useEffect(
      () => {
        const listener = (event) => {

          // Do nothing if clicking ref's element or descendent elements
          if (!ref.current || ref.current.contains(event.target)) {
            return;
          }
          handler(event);
        };
        document.addEventListener("mousedown", listener);
        document.addEventListener("touchstart", listener);
        return () => {
          document.removeEventListener("mousedown", listener);
          document.removeEventListener("touchstart", listener);
        };
      },
      [ref, handler]
    );
  }

  const dropDownItem = (action, text, src) => {
    return (
      <div className={`${style.dropDownItem}`}
        onClick={action}>
        {/* <div className={style.iconContainer}>
          <img src={src} className={style.icon} />
        </div> */}
        <div style={{ paddingTop: "5px", paddingBottom: "5px" }}>
          {text}
        </div>
      </div>
    )
  }

  return (
    <div className={`${style.CallButtons}`}>
      <ButtonCall
        imgOn={IcoVideo}
        imgOff={IcoVideoNo}
        onClick={onToggleCamera}
      />
      <ButtonCall imgOn={IcoMic} imgOff={IcoMicNo} onClick={onToggleAudio} />
      <div style={{ margin: "0" }}>
        <EndCallButton onClick={onCloseCall} />
      </div>
      <ButtonCall
        checked={showMenu}
        imgOn={IcoShareNo}
        imgOff={IcoShare}
        onClick={(e) => {
          setShowMenu(!showMenu);
        }}
      />
      {showMenu &&
        <div ref={menuRef} className={style.dropDown}
          onClick={(e) => {
            setShowMenu(false);
          }}>
          {dropDownItem(onToggleLocalScreenShare, translations.shareYourScreen, IcoShare)}
          <div className={`${style.separator}`}></div>
          {dropDownItem(
            onToggleRemoteShareScreen,
            showRemoteSharedScreen ? translations.stopPatientScreen : translations.askPatientToShare,
            IcoShare
          )
          }
        </div>
      }
      <ButtonCall
        imgOn={IcoRec}
        imgOff={IcoStop}
        // TODO: remove onClickRecording from codebase
        onClick={onToggleRecording}
        customClass={"record"}
      />
    </div>
  );
}

CallButtons.propTypes = {};

CallButtons.defaultProps = {};

export default CallButtons;
